export default "__VITE_ASSET__BufqXlzl__"